import { render, staticRenderFns } from "./EventDashboard.vue?vue&type=template&id=e0ae1efe&scoped=true&"
import script from "./EventDashboard.vue?vue&type=script&lang=js&"
export * from "./EventDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ae1efe",
  null
  
)

export default component.exports